class KlaviyoNotify extends HTMLElement {
  constructor() {
    super();
    this.notifyModal = this;
    this.notifyModalOverlay = this.notifyModal.querySelector(
      '[data-notify-modal-overlay]'
    );
    this.notifyModalCloseButton = this.notifyModal.querySelector(
      '[data-notify-modal-close]'
    );
    this.notifyForm = this.notifyModal.querySelector('[data-notify-form]');
    this.notifyVariantInput = this.notifyModal.querySelector(
      '[data-notify-variant-input]'
    );
    this.notifyCompanyId = this.notifyModal.dataset.notifyCompanyId;
    this.notifySuccessMessage = this.notifyModal.querySelector(
      '[data-notify-success]'
    );
    this.notifyErrorMessage = this.notifyModal.querySelector(
      '[data-notify-error]'
    );
    this.notifySubmittingText = this.notifyModal.dataset.submittingText;
    this.notifyGetNotifiedText = this.notifyModal.dataset.getNotifiedText;
  }

  connectedCallback() {
    document.addEventListener('klaviyo-notify:open', () =>
      this.openNotifyModal()
    );
    this.notifyModalCloseButton.addEventListener('click', () =>
      this.closeNotifyModal()
    );
    this.notifyModalOverlay.addEventListener('click', () =>
      this.closeNotifyModal()
    );
    this.notifyForm.addEventListener('submit', (e) =>
      this.handleNotifySubmit(e)
    );
  }

  disconnectedCallback() {
    document.removeEventListener('klaviyo-notify:open', () =>
      this.openNotifyModal()
    );
    this.notifyModalCloseButton.removeEventListener('click', () =>
      this.closeNotifyModal()
    );
    this.notifyModalOverlay.removeEventListener('click', () =>
      this.closeNotifyModal()
    );
    this.notifyForm.removeEventListener('submit', (e) =>
      this.handleNotifySubmit(e)
    );
  }

  async handleNotifySubmit(e) {
    e.preventDefault();

    const form = e.target;
    const email = form.querySelector('input[name="email"]').value;
    const variantId = this.notifyVariantInput.value;
    const buttonText = form.querySelector('[data-notify-submit-text]');
    const submitButton = form.querySelector('button[type="submit"]');

    if (!email || !variantId) return;

    try {
      submitButton.disabled = true;
      if (buttonText) {
        buttonText.textContent = this.notifySubmittingText;
      }

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId,
              },
            },
          },
        },
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.notifyCompanyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        if (this.notifySuccessMessage) {
          this.notifySuccessMessage.classList.remove('hidden');
        }
        form.reset();
      } else {
        if (this.notifyErrorMessage) {
          this.notifyErrorMessage.classList.remove('hidden');
        }
      }
    } catch (error) {
      console.error('Notify subscription error:', error);
      if (this.notifyErrorMessage) {
        this.notifyErrorMessage.classList.remove('hidden');
      }
    } finally {
      setTimeout(() => {
        submitButton.disabled = false;
        if (this.notifySuccessMessage) {
          this.notifySuccessMessage.classList.add('hidden');
        }
        if (this.notifyErrorMessage) {
          this.notifyErrorMessage.classList.add('hidden');
        }
        if (this.notifyGetNotifiedText) {
          buttonText.textContent = this.notifyGetNotifiedText;
        }
      }, 3000);
    }
  }

  openNotifyModal() {
    this.notifyModal.classList.remove('hidden');
    this.notifyModal.classList.add('flex');
    this.notifyModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
  }

  closeNotifyModal() {
    this.notifyModal.classList.remove('flex');
    this.notifyModal.classList.add('hidden');
    this.notifyModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('klaviyo-notify')) {
  customElements.define('klaviyo-notify', KlaviyoNotify);
}
